<div class="w-full bg-[#fcfdff] border-t-[1px] border-t-[#C9DDF480]">
    <div class="max-w-[40rem] flex justify-center">
        <div class="p-8">
            <div class="bg-exclamation-icon icon-[6.25rem] m-auto"></div>

            <p class="text-black font-semibold text-2xl text-center mt-2">
                {{ 'error.multipleLoginErrorTitle' | translate }}
            </p>

            <div
                class="text-[#5F5B5B] font-lato text-base font-normal text-center mt-4"
                [innerHTML]="'error.multipleLoginErrorDescription1' | translate"></div>

            <button type="button" class="btn-primary mt-6 m-auto button-padding" (click)="redirect()">
                {{ 'button.goToLoginPageNow' | translate }}
            </button>

            <div
                class="text-[#5F5B5B] font-lato text-sm font-normal text-center mt-6"
                [innerHTML]="'error.multipleLoginRedirectionCounter' | translate: { counter: counter }"></div>
        </div>
    </div>
</div>
